import * as React from 'react'

import { Box, Divider, Spinner, Table } from '@factorialco/deprecated-design-system'
import groupBy from 'lodash/groupBy'

import { observer } from 'mobx-react'

import { useAssessments } from 'modules/competencies/pages/assessmentsContext'
import { useCompetencies } from 'modules/competencies/pages/competenciesContext'
import type { Assessment } from 'modules/competencies/store/models/Assessment'
import type { AssessmentGroup } from 'modules/competencies/store/models/AssessmentGroup'
import type { EmployeeAssessmentGroup } from 'modules/competencies/store/models/EmployeeAssessmentGroup'

import CompetenciesTable from './CompetenciesTable'
import Navigator from './Navigator'
import SpiderWeb from './SpiderWeb'

interface Props {
  employeeAssessmentGroups: EmployeeAssessmentGroup[] | AssessmentGroup[]
}

const Competencies = ({ employeeAssessmentGroups }: Props) => {
  const { loading: loadingCompetencies } = useCompetencies()
  const { assessments, loading } = useAssessments()
  const lastAssessmentPosition = employeeAssessmentGroups.length - 1
  const [currentAssessmentPosition, setCurrentAssessmentPosition] =
    React.useState(lastAssessmentPosition)
  const currentAssessmentGroup = employeeAssessmentGroups[currentAssessmentPosition]

  if (loading || loadingCompetencies) return <Spinner />

  if (!currentAssessmentGroup) return null

  const currentDate = currentAssessmentGroup.attributes.created_at

  const currentAssessments = assessments.filter({
    assessment_group_id: currentAssessmentGroup.attributes.id,
  })

  const groupedAssessments: {
    [parentId: string]: Assessment[]
  } = groupBy(currentAssessments, (assessment) => {
    if (!assessment.competency.parent) return assessment.competency.attributes.id

    return assessment.competency.parent.attributes.id
  })

  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Box flexDirection="column" width="full">
            <Box
              flexDirection="row"
              padding="s16"
              justifyContent="spaceBetween"
              aria-label="assessment-navigator"
              background="grey100"
            >
              <Navigator
                currentPosition={currentAssessmentPosition}
                setCurrentPosition={setCurrentAssessmentPosition}
                lastPosition={lastAssessmentPosition}
                currentDate={currentDate}
              />
            </Box>
            <Divider />
            <SpiderWeb assessments={currentAssessments} />
            {Object.keys(groupedAssessments).map((parentId) => {
              const assessments = groupedAssessments[+parentId]

              if (!assessments) return null

              const parentAssessment = assessments.find(
                (a) => a.competency.attributes.id === +parentId
              )
              const childAssessments = assessments.filter(
                (a) => a.competency.parent?.attributes.id === +parentId
              )

              return (
                <CompetenciesTable
                  key={parentId}
                  parentAssessment={parentAssessment}
                  childAssessments={childAssessments}
                />
              )
            })}
          </Box>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

export default observer(Competencies)
